import React from 'react';
import "./Home.css"
import { FaSquareInstagram,FaSquareGithub ,FaCodepen,FaLinkedin } from "react-icons/fa6";
const Footer=()=>{

    return(
        <>
        <div className="">
            <footer className=" px-5  text-white py-6">
                <div className="logos  flex justify-center p-3 gap-8 rounded-xl">
                    <a rel="noreferrer" href="https://github.com/utkarsh2004git" target="_blank">
                        < FaSquareGithub size={50} className='hover:scale-125 duration-200'/>
                    </a>
                    <a rel="noreferrer" href="https://instagram.com/utkarsh_001122" target="_blank">
                        < FaSquareInstagram size={50} className='hover:scale-125 duration-200'/>                        
                    </a>
                    <a rel="noreferrer" href="https://www.linkedin.com/in/utkarsh-shahare-7b4109214/" target="_blank">
                        < FaLinkedin size={50} className='hover:scale-125 duration-200'/>
                    </a>
                    <a rel="noreferrer" href="https://codepen.io/utkarsh_001122" target="_blank">
                        < FaCodepen size={50} className='hover:scale-125 duration-200'/>
                    </a>
       
                </div>

            </footer>
        </div>
        </>
    )
}


export default Footer;